export const complaintColumn = [
  {
    title: '游戏名称',
    key: 'game_name',
    type: 'text',
  },
  {
    title: '账号',
    key: 'account',
    type: 'text',
  },
  {
    title: '角色名',
    key: 'game_role_name',
    type: 'text',
  },
  {
    title: '区服',
    key: 'game_server',
    type: 'text',
  },
  {
    title: '总充值',
    key: 'total_money',
    type: 'text',
  },
  {
    title: '状态',
    key: 'audit_status',
    type: 'text',
  },
  {
    title: '提交人',
    key: 'submit_admin_name',
    type: 'text',
  },
  {
    title: '投诉类型',
    key: 'complaint_type',
    type: 'text',
  },
  {
    title: '风险类型',
    key: 'risk_type',
    type: 'text',
  },
  {
    title: '风险等级',
    key: 'risk_type',
    type: 'text',
  },
  {
    title: '是否升级',
    key: 'upgrade_type',
    type: 'text',
  },
  {
    title: '问题详情',
    key: 'complaint_content',
    type: 'text',
  },
  {
    title: '安抚详情',
    key: 'comfort_content',
    type: 'text',
  },
  {
    title: '提交时间',
    key: 'created_at',
    type: 'text',
  },
  {
    title: '图片',
    key: 'images',
    type: 'images',
    width: 200,
    height: 600,
  },
  {
    title: '内部/外部',
    key: 'submit_type',
    type: 'text',
  },
  {
    title: '审批人',
    key: 'audit_admin',
    type: 'text',
  },
];
